import { render, staticRenderFns } from "./alert-window.vue?vue&type=template&id=38f1490a"
import script from "./alert-window.vue?vue&type=script&lang=js"
export * from "./alert-window.vue?vue&type=script&lang=js"
import style0 from "./alert-window.vue?vue&type=style&index=0&id=38f1490a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports